import { baseApi } from 'src/store/APIs'

import {
  addPurchaseTodo,
  deletePurchaseTodo,
  getPurchaseTodo,
  getSurvivorsPurchaseTodos,
  updatePurchaseTodo,
} from './actions'

export const purchaseTodosApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    addPurchaseTodo: addPurchaseTodo(builder),
    deletePurchaseTodo: deletePurchaseTodo(builder),
    getPurchaseTodo: getPurchaseTodo(builder),
    getSurvivorsPurchaseTodos: getSurvivorsPurchaseTodos(builder),
    updatePurchaseTodo: updatePurchaseTodo(builder),
  }),
})

export const {
  useGetSurvivorsPurchaseTodosQuery,
  useLazyGetSurvivorsPurchaseTodosQuery,
  useLazyGetPurchaseTodoQuery,
  useAddPurchaseTodoMutation,
  useUpdatePurchaseTodoMutation,
  useDeletePurchaseTodoMutation,
} = purchaseTodosApi
